var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuantifiedNarratives(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.14285H0.571429C0.255837 9.14285 0 9.39869 0 9.71428V15.4286C0 15.7442 0.255837 16 0.571429 16H4C4.31559 16 4.57143 15.7442 4.57143 15.4286V9.71428C4.57143 9.39869 4.31559 9.14285 4 9.14285Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 4.57144H12C11.6844 4.57144 11.4286 4.82728 11.4286 5.14287V15.4286C11.4286 15.7442 11.6844 16 12 16H15.4286C15.7442 16 16 15.7442 16 15.4286V5.14287C16 4.82728 15.7442 4.57144 15.4286 4.57144Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71387 0H6.2853C5.9697 0 5.71387 0.255837 5.71387 0.571429V15.4286C5.71387 15.7442 5.9697 16 6.2853 16H9.71387C10.0295 16 10.2853 15.7442 10.2853 15.4286V0.571429C10.2853 0.255837 10.0295 0 9.71387 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantifiedNarratives);
export default __webpack_public_path__ + "static/media/quantified-narratives.aebca6ea21dbda40ec615cdeb2d54d65.svg";
export { ForwardRef as ReactComponent };